"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Cowtroller Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.130
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DevicesApiFactory = exports.DevicesApiFp = exports.DevicesApiAxiosParamCreator = exports.DevicePayloadApi = exports.DevicePayloadApiFactory = exports.DevicePayloadApiFp = exports.DevicePayloadApiAxiosParamCreator = exports.CowtrollerCleanUpApi = exports.CowtrollerCleanUpApiFactory = exports.CowtrollerCleanUpApiFp = exports.CowtrollerCleanUpApiAxiosParamCreator = exports.CowtrollerCleanStaleDataApi = exports.CowtrollerCleanStaleDataApiFactory = exports.CowtrollerCleanStaleDataApiFp = exports.CowtrollerCleanStaleDataApiAxiosParamCreator = exports.CowtrollerBreakFenceApi = exports.CowtrollerBreakFenceApiFactory = exports.CowtrollerBreakFenceApiFp = exports.CowtrollerBreakFenceApiAxiosParamCreator = exports.CommandApi = exports.CommandApiFactory = exports.CommandApiFp = exports.CommandApiAxiosParamCreator = exports.RequestMessagePriorityEnum = exports.ProtrackDraftingStatusEnum = exports.ProtrackDraftingDirectionEnum = exports.PaddockTypeEnum = exports.LogLevelEnum = exports.IPolygonTypeDTOTypeEnum = exports.IDevicePayloadTypeEnum = exports.IDevicePayloadStatusEnum = exports.IDevicePayloadSettingsPayloadTypeEnum = exports.IDevicePayloadMapFeaturePayloadTypeEnum = exports.ICowtrollerGroupUpdateTypeEnum = exports.ICowtrollerDeviceUpdateTypeEnum = exports.ICowtrollerDeviceStateUpdateTypeEnum = exports.HeadingTestOverrideEnum = exports.DropBreakFenceIntentEnum = exports.DeviceNotificationTypeEnum = exports.DeviceMessageStatusEnum = exports.DeviceMessageOriginEnum = exports.DeviceCommandStatusEnum = exports.DeviceActiveCommandUpdateTypeEnum = exports.DeviceActiveCommandStatusEnum = exports.CowtrollerDeviceStatusEnum = exports.CowtrollerCattleStatusEnum = exports.CommandTypeEnum = exports.CommandStatusEnum = exports.CommandOriginEnum = exports.BreakFenceStatusEnum = void 0;
exports.ProtrackDraftingApi = exports.ProtrackDraftingApiFactory = exports.ProtrackDraftingApiFp = exports.ProtrackDraftingApiAxiosParamCreator = exports.GroupsApi = exports.GroupsApiFactory = exports.GroupsApiFp = exports.GroupsApiAxiosParamCreator = exports.EmergencyReleaseApi = exports.EmergencyReleaseApiFactory = exports.EmergencyReleaseApiFp = exports.EmergencyReleaseApiAxiosParamCreator = exports.DevicesApi = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.BreakFenceStatusEnum = {
    UPCOMING: 'UPCOMING',
    ACTIVE: 'ACTIVE',
    DROPPED: 'DROPPED',
    CANCELLED: 'CANCELLED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CommandOriginEnum = {
    UPCOMING_BREAK: 'UPCOMING_BREAK',
    BREAK_SHAPE_UPDATED: 'BREAK_SHAPE_UPDATED',
    BREAK_CANCELLED: 'BREAK_CANCELLED',
    BREAK_DELETED: 'BREAK_DELETED',
    DROP_FENCE_NO_SHIFT: 'DROP_FENCE_NO_SHIFT',
    DROP_FENCE_SHIFT_TO_NEXT: 'DROP_FENCE_SHIFT_TO_NEXT',
    DROP_FENCE_EXIT_PADDOCK: 'DROP_FENCE_EXIT_PADDOCK',
    FUTURE_COMMAND_CANCELLED: 'FUTURE_COMMAND_CANCELLED',
    EXIT_PADDOCK_SHIFT: 'EXIT_PADDOCK_SHIFT',
    INCIDENT: 'INCIDENT',
    BREAK_TO_BREAK_NEW_AREA_SHIFT: 'BREAK_TO_BREAK_NEW_AREA_SHIFT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CommandStatusEnum = {
    CURRENT: 'CURRENT',
    COMPLETED: 'COMPLETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CommandTypeEnum = {
    SET_ZONE: 'SET_ZONE',
    EXIT_ZONE: 'EXIT_ZONE',
    PAUSE: 'PAUSE',
    DELETE_COMMANDS: 'DELETE_COMMANDS',
    CLEAR_STATE: 'CLEAR_STATE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowtrollerCattleStatusEnum = {
    UNDER_HALTER_CONTROL: 'UnderHalterControl',
    UNDER_FARMER_CONTROL: 'UnderFarmerControl',
    COW_ESCAPED: 'CowEscaped'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CowtrollerDeviceStatusEnum = {
    ACTIVE: 'Active',
    DISABLED: 'Disabled',
    UNRESPONSIVE: 'Unresponsive'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DeviceActiveCommandStatusEnum = {
    ACTIVE: 'ACTIVE',
    HARD_SHOCK_LOCKED_OUT: 'HARD_SHOCK_LOCKED_OUT',
    REACHED_DESTINATION: 'REACHED_DESTINATION'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DeviceActiveCommandUpdateTypeEnum = {
    ACTIVATED: 'ACTIVATED',
    HARD_SHOCK_LOCKED_OUT: 'HARD_SHOCK_LOCKED_OUT',
    REACHED_DESTINATION: 'REACHED_DESTINATION',
    DEACTIVATED: 'DEACTIVATED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DeviceCommandStatusEnum = {
    NOT_SYNCED: 'NOT_SYNCED',
    SYNCING: 'SYNCING',
    SYNCED: 'SYNCED',
    FAILED_TO_SYNC: 'FAILED_TO_SYNC',
    ACTIVE: 'ACTIVE',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DeviceMessageOriginEnum = {
    RECONCILIATION: 'Reconciliation',
    SCHEDULE_UPDATE: 'ScheduleUpdate',
    SCHEDULE_UPDATE_FIRST_SCHEDULE: 'ScheduleUpdateFirstSchedule',
    LOCATION_UPDATE_IN_PADDOCK: 'LocationUpdateInPaddock',
    CLEAN_UP_COW_ESCAPED: 'CleanUpCowEscaped',
    CLEAN_UP_DEVICE_UNASSIGNED: 'CleanUpDeviceUnassigned',
    DEVICE_ASSIGNED_TO_CATTLE: 'DeviceAssignedToCattle',
    LOCATION_UPDATE_OUT_OF_PADDOCK: 'LocationUpdateOutOfPaddock',
    CLEAN_UP_DEVICE_DISABLED: 'CleanUpDeviceDisabled'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DeviceMessageStatusEnum = {
    SCHEDULED: 'Scheduled',
    CONFIRMED: 'Confirmed',
    EXPIRED: 'Expired',
    FAILED: 'Failed'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DeviceNotificationTypeEnum = {
    LOCATION: 'LOCATION',
    STATE_REPORT: 'STATE_REPORT',
    ACTIVE_COMMAND: 'ACTIVE_COMMAND'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DropBreakFenceIntentEnum = {
    DROP_FENCE: 'DROP_FENCE',
    NEXT_BREAK: 'NEXT_BREAK',
    EXIT_PADDOCK: 'EXIT_PADDOCK'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.HeadingTestOverrideEnum = {
    NONE: 'HEADING_TEST_OVERRIDE_NONE',
    FORCE_PASS: 'HEADING_TEST_OVERRIDE_FORCE_PASS',
    FORCE_FAIL: 'HEADING_TEST_OVERRIDE_FORCE_FAIL'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ICowtrollerDeviceStateUpdateTypeEnum = {
    RECONCILIATION_UPDATE: 'ReconciliationUpdate',
    NEW_DESIRED_STATE: 'NewDesiredState',
    DEVICE_MESSAGE_INFORMATION: 'DeviceMessageInformation',
    LAST_REPORTED_STATE_UPDATE: 'LastReportedStateUpdate'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ICowtrollerDeviceUpdateTypeEnum = {
    COWTROLLER_DEVICE_CREATED: 'CowtrollerDeviceCreated',
    GROUP_PADDOCK_UPDATE: 'GroupPaddockUpdate',
    CATTLE_STATUS: 'CattleStatus',
    CATTLE_INFORMATION: 'CattleInformation'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ICowtrollerGroupUpdateTypeEnum = {
    GROUP_CREATED: 'GROUP_CREATED',
    DEVICE_ADDED: 'DEVICE_ADDED',
    DEVICE_REMOVED: 'DEVICE_REMOVED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IDevicePayloadMapFeaturePayloadTypeEnum = {
    EXIT_POINT: 'EXIT_POINT',
    PADDOCK: 'PADDOCK',
    DATUM: 'DATUM'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IDevicePayloadSettingsPayloadTypeEnum = {
    COWG_SYSTEM: 'COWG_SYSTEM',
    COWG_HOLD_IN_ZONE: 'COWG_HOLD_IN_ZONE',
    COWG_HOLD_IN_ZONE_CROP: 'COWG_HOLD_IN_ZONE_CROP',
    COWG_ENTER_PADDOCK: 'COWG_ENTER_PADDOCK',
    COWG_EXIT_PADDOCK: 'COWG_EXIT_PADDOCK',
    COWG_EXIT_PADDOCK_CROP: 'COWG_EXIT_PADDOCK_CROP',
    COWG_EXIT_PADDOCK_DRAFTING: 'COWG_EXIT_PADDOCK_DRAFTING',
    COWG_BREAK_TO_BREAK: 'COWG_BREAK_TO_BREAK',
    COWG_BREAK_TO_BREAK_CROP: 'COWG_BREAK_TO_BREAK_CROP',
    COWG_SHARED_BOUNDARY_TRANSITION: 'COWG_SHARED_BOUNDARY_TRANSITION',
    COWG_RACE_NAVIGATION: 'COWG_RACE_NAVIGATION',
    CONTROL: 'CONTROL',
    OPERATIONAL: 'OPERATIONAL',
    ENGINEERING: 'ENGINEERING',
    EXPERIMENTAL: 'EXPERIMENTAL',
    CALIBRATION: 'CALIBRATION',
    FIRMWARE_UPDATE: 'FIRMWARE_UPDATE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IDevicePayloadStatusEnum = {
    NOT_SYNCED: 'NOT_SYNCED',
    SYNCING: 'SYNCING',
    SYNCED: 'SYNCED',
    FAILED_TO_SYNC: 'FAILED_TO_SYNC'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.IDevicePayloadTypeEnum = {
    MAP_FEATURE: 'MAP_FEATURE',
    SETTINGS: 'SETTINGS'
};
exports.IPolygonTypeDTOTypeEnum = {
    POLYGON: 'Polygon'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LogLevelEnum = {
    NONE: 'LOG_LEVEL_NONE',
    ERROR: 'LOG_LEVEL_ERROR',
    WARN: 'LOG_LEVEL_WARN',
    INFO: 'LOG_LEVEL_INFO',
    DEBUG: 'LOG_LEVEL_DEBUG',
    VERBOSE: 'LOG_LEVEL_VERBOSE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.PaddockTypeEnum = {
    ALL_TYPES: 'ALL_TYPES',
    PASTURE: 'PASTURE',
    CROP: 'CROP'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProtrackDraftingDirectionEnum = {
    RIGHT: 'RIGHT',
    LEFT: 'LEFT'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProtrackDraftingStatusEnum = {
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
    TO_BE_DELETED: 'TO_BE_DELETED'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.RequestMessagePriorityEnum = {
    HIGHEST: 'HIGHEST',
    HIGH: 'HIGH',
    MEDIUM_HIGH: 'MEDIUM_HIGH',
    NORMAL: 'NORMAL',
    MEDIUM_LOW: 'MEDIUM_LOW',
    LOW: 'LOW',
    LOWEST: 'LOWEST'
};
/**
 * CommandApi - axios parameter creator
 * @export
 */
var CommandApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Retrieves a Command.
         * @param {string} commandId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommand: function (commandId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'commandId' is not null or undefined
                    (0, common_1.assertParamExists)('getCommand', 'commandId', commandId);
                    localVarPath = "/cowtroller/commands/{commandId}"
                        .replace("{".concat("commandId", "}"), encodeURIComponent(String(commandId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a list of all existing commands for context farm.
         * @param {number} [pageSize] Number of items to be returned
         * @param {number} [offset] Offset to be taken according to the underlying page and page size
         * @param {number} [collarCommandId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommands: function (pageSize, offset, collarCommandId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/commands";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (collarCommandId !== undefined) {
                        localVarQueryParameter['collarCommandId'] = collarCommandId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CommandApiAxiosParamCreator = CommandApiAxiosParamCreator;
/**
 * CommandApi - functional programming interface
 * @export
 */
var CommandApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CommandApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Retrieves a Command.
         * @param {string} commandId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommand: function (commandId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCommand(commandId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a list of all existing commands for context farm.
         * @param {number} [pageSize] Number of items to be returned
         * @param {number} [offset] Offset to be taken according to the underlying page and page size
         * @param {number} [collarCommandId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommands: function (pageSize, offset, collarCommandId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCommands(pageSize, offset, collarCommandId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CommandApiFp = CommandApiFp;
/**
 * CommandApi - factory interface
 * @export
 */
var CommandApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CommandApiFp)(configuration);
    return {
        /**
         *
         * @summary Retrieves a Command.
         * @param {string} commandId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommand: function (commandId, options) {
            return localVarFp.getCommand(commandId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a list of all existing commands for context farm.
         * @param {number} [pageSize] Number of items to be returned
         * @param {number} [offset] Offset to be taken according to the underlying page and page size
         * @param {number} [collarCommandId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommands: function (pageSize, offset, collarCommandId, options) {
            return localVarFp.getCommands(pageSize, offset, collarCommandId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CommandApiFactory = CommandApiFactory;
/**
 * CommandApi - object-oriented interface
 * @export
 * @class CommandApi
 * @extends {BaseAPI}
 */
var CommandApi = /** @class */ (function (_super) {
    __extends(CommandApi, _super);
    function CommandApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Retrieves a Command.
     * @param {string} commandId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandApi
     */
    CommandApi.prototype.getCommand = function (commandId, options) {
        var _this = this;
        return (0, exports.CommandApiFp)(this.configuration).getCommand(commandId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a list of all existing commands for context farm.
     * @param {number} [pageSize] Number of items to be returned
     * @param {number} [offset] Offset to be taken according to the underlying page and page size
     * @param {number} [collarCommandId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommandApi
     */
    CommandApi.prototype.getCommands = function (pageSize, offset, collarCommandId, options) {
        var _this = this;
        return (0, exports.CommandApiFp)(this.configuration).getCommands(pageSize, offset, collarCommandId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CommandApi;
}(base_1.BaseAPI));
exports.CommandApi = CommandApi;
/**
 * CowtrollerBreakFenceApi - axios parameter creator
 * @export
 */
var CowtrollerBreakFenceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Endpoint to inform cowtroller of break-fence drop
         * @param {IDropBreakFenceEventDTO} [iDropBreakFenceEventDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleDropBreakFenceEvent: function (iDropBreakFenceEventDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/break-fence-event/drop";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDropBreakFenceEventDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CowtrollerBreakFenceApiAxiosParamCreator = CowtrollerBreakFenceApiAxiosParamCreator;
/**
 * CowtrollerBreakFenceApi - functional programming interface
 * @export
 */
var CowtrollerBreakFenceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CowtrollerBreakFenceApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Endpoint to inform cowtroller of break-fence drop
         * @param {IDropBreakFenceEventDTO} [iDropBreakFenceEventDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleDropBreakFenceEvent: function (iDropBreakFenceEventDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.handleDropBreakFenceEvent(iDropBreakFenceEventDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CowtrollerBreakFenceApiFp = CowtrollerBreakFenceApiFp;
/**
 * CowtrollerBreakFenceApi - factory interface
 * @export
 */
var CowtrollerBreakFenceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CowtrollerBreakFenceApiFp)(configuration);
    return {
        /**
         *
         * @summary Endpoint to inform cowtroller of break-fence drop
         * @param {IDropBreakFenceEventDTO} [iDropBreakFenceEventDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleDropBreakFenceEvent: function (iDropBreakFenceEventDTO, options) {
            return localVarFp.handleDropBreakFenceEvent(iDropBreakFenceEventDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CowtrollerBreakFenceApiFactory = CowtrollerBreakFenceApiFactory;
/**
 * CowtrollerBreakFenceApi - object-oriented interface
 * @export
 * @class CowtrollerBreakFenceApi
 * @extends {BaseAPI}
 */
var CowtrollerBreakFenceApi = /** @class */ (function (_super) {
    __extends(CowtrollerBreakFenceApi, _super);
    function CowtrollerBreakFenceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Endpoint to inform cowtroller of break-fence drop
     * @param {IDropBreakFenceEventDTO} [iDropBreakFenceEventDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CowtrollerBreakFenceApi
     */
    CowtrollerBreakFenceApi.prototype.handleDropBreakFenceEvent = function (iDropBreakFenceEventDTO, options) {
        var _this = this;
        return (0, exports.CowtrollerBreakFenceApiFp)(this.configuration).handleDropBreakFenceEvent(iDropBreakFenceEventDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CowtrollerBreakFenceApi;
}(base_1.BaseAPI));
exports.CowtrollerBreakFenceApi = CowtrollerBreakFenceApi;
/**
 * CowtrollerCleanStaleDataApi - axios parameter creator
 * @export
 */
var CowtrollerCleanStaleDataApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Endpoint to clean up old data to prevent the database tables from growing forever
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanStaleData: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/clean-stale-data";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CowtrollerCleanStaleDataApiAxiosParamCreator = CowtrollerCleanStaleDataApiAxiosParamCreator;
/**
 * CowtrollerCleanStaleDataApi - functional programming interface
 * @export
 */
var CowtrollerCleanStaleDataApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CowtrollerCleanStaleDataApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Endpoint to clean up old data to prevent the database tables from growing forever
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanStaleData: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cleanStaleData(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CowtrollerCleanStaleDataApiFp = CowtrollerCleanStaleDataApiFp;
/**
 * CowtrollerCleanStaleDataApi - factory interface
 * @export
 */
var CowtrollerCleanStaleDataApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CowtrollerCleanStaleDataApiFp)(configuration);
    return {
        /**
         *
         * @summary Endpoint to clean up old data to prevent the database tables from growing forever
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanStaleData: function (options) {
            return localVarFp.cleanStaleData(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CowtrollerCleanStaleDataApiFactory = CowtrollerCleanStaleDataApiFactory;
/**
 * CowtrollerCleanStaleDataApi - object-oriented interface
 * @export
 * @class CowtrollerCleanStaleDataApi
 * @extends {BaseAPI}
 */
var CowtrollerCleanStaleDataApi = /** @class */ (function (_super) {
    __extends(CowtrollerCleanStaleDataApi, _super);
    function CowtrollerCleanStaleDataApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Endpoint to clean up old data to prevent the database tables from growing forever
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CowtrollerCleanStaleDataApi
     */
    CowtrollerCleanStaleDataApi.prototype.cleanStaleData = function (options) {
        var _this = this;
        return (0, exports.CowtrollerCleanStaleDataApiFp)(this.configuration).cleanStaleData(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CowtrollerCleanStaleDataApi;
}(base_1.BaseAPI));
exports.CowtrollerCleanStaleDataApi = CowtrollerCleanStaleDataApi;
/**
 * CowtrollerCleanUpApi - axios parameter creator
 * @export
 */
var CowtrollerCleanUpApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUp: function (farmId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'farmId' is not null or undefined
                    (0, common_1.assertParamExists)('cleanUp', 'farmId', farmId);
                    localVarPath = "/cowtroller/clean-up/{farmId}"
                        .replace("{".concat("farmId", "}"), encodeURIComponent(String(farmId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.CowtrollerCleanUpApiAxiosParamCreator = CowtrollerCleanUpApiAxiosParamCreator;
/**
 * CowtrollerCleanUpApi - functional programming interface
 * @export
 */
var CowtrollerCleanUpApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.CowtrollerCleanUpApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUp: function (farmId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.cleanUp(farmId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.CowtrollerCleanUpApiFp = CowtrollerCleanUpApiFp;
/**
 * CowtrollerCleanUpApi - factory interface
 * @export
 */
var CowtrollerCleanUpApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.CowtrollerCleanUpApiFp)(configuration);
    return {
        /**
         *
         * @param {string} farmId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cleanUp: function (farmId, options) {
            return localVarFp.cleanUp(farmId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.CowtrollerCleanUpApiFactory = CowtrollerCleanUpApiFactory;
/**
 * CowtrollerCleanUpApi - object-oriented interface
 * @export
 * @class CowtrollerCleanUpApi
 * @extends {BaseAPI}
 */
var CowtrollerCleanUpApi = /** @class */ (function (_super) {
    __extends(CowtrollerCleanUpApi, _super);
    function CowtrollerCleanUpApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param {string} farmId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CowtrollerCleanUpApi
     */
    CowtrollerCleanUpApi.prototype.cleanUp = function (farmId, options) {
        var _this = this;
        return (0, exports.CowtrollerCleanUpApiFp)(this.configuration).cleanUp(farmId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return CowtrollerCleanUpApi;
}(base_1.BaseAPI));
exports.CowtrollerCleanUpApi = CowtrollerCleanUpApi;
/**
 * DevicePayloadApi - axios parameter creator
 * @export
 */
var DevicePayloadApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Retrieves a list of device payloads
         * @param {Array<string>} [serialNumbers] Filter to devices in list
         * @param {Array<IDevicePayloadTypeEnum>} [payloadType] Filter to only return device payloads of the types in the list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePayload: function (serialNumbers, payloadType, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/device-payload";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (serialNumbers) {
                        localVarQueryParameter['serialNumbers'] = serialNumbers;
                    }
                    if (payloadType) {
                        localVarQueryParameter['payloadType'] = payloadType;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves device payload for a specific device
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePayloadBySerialNumber: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('getDevicePayloadBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/cowtroller/device-payload/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a list of device payload summaries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePayloadSummaries: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/device-payload/summaries";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a list of settings device payloads
         * @param {Array<string>} [serialNumbers] Filter to devices in list
         * @param {Array<IDevicePayloadSettingsPayloadTypeEnum>} [settingsTypes] Filter to only return device payloads of the settings type in the list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettingsDevicePayloads: function (serialNumbers, settingsTypes, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/device-payload/settings";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (serialNumbers) {
                        localVarQueryParameter['serialNumbers'] = serialNumbers;
                    }
                    if (settingsTypes) {
                        localVarQueryParameter['settingsTypes'] = settingsTypes;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DevicePayloadApiAxiosParamCreator = DevicePayloadApiAxiosParamCreator;
/**
 * DevicePayloadApi - functional programming interface
 * @export
 */
var DevicePayloadApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DevicePayloadApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Retrieves a list of device payloads
         * @param {Array<string>} [serialNumbers] Filter to devices in list
         * @param {Array<IDevicePayloadTypeEnum>} [payloadType] Filter to only return device payloads of the types in the list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePayload: function (serialNumbers, payloadType, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDevicePayload(serialNumbers, payloadType, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves device payload for a specific device
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePayloadBySerialNumber: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDevicePayloadBySerialNumber(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a list of device payload summaries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePayloadSummaries: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDevicePayloadSummaries(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a list of settings device payloads
         * @param {Array<string>} [serialNumbers] Filter to devices in list
         * @param {Array<IDevicePayloadSettingsPayloadTypeEnum>} [settingsTypes] Filter to only return device payloads of the settings type in the list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettingsDevicePayloads: function (serialNumbers, settingsTypes, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSettingsDevicePayloads(serialNumbers, settingsTypes, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DevicePayloadApiFp = DevicePayloadApiFp;
/**
 * DevicePayloadApi - factory interface
 * @export
 */
var DevicePayloadApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DevicePayloadApiFp)(configuration);
    return {
        /**
         *
         * @summary Retrieves a list of device payloads
         * @param {Array<string>} [serialNumbers] Filter to devices in list
         * @param {Array<IDevicePayloadTypeEnum>} [payloadType] Filter to only return device payloads of the types in the list
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePayload: function (serialNumbers, payloadType, options) {
            return localVarFp.getDevicePayload(serialNumbers, payloadType, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves device payload for a specific device
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePayloadBySerialNumber: function (serialNumber, options) {
            return localVarFp.getDevicePayloadBySerialNumber(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a list of device payload summaries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicePayloadSummaries: function (options) {
            return localVarFp.getDevicePayloadSummaries(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a list of settings device payloads
         * @param {Array<string>} [serialNumbers] Filter to devices in list
         * @param {Array<IDevicePayloadSettingsPayloadTypeEnum>} [settingsTypes] Filter to only return device payloads of the settings type in the list.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSettingsDevicePayloads: function (serialNumbers, settingsTypes, options) {
            return localVarFp.getSettingsDevicePayloads(serialNumbers, settingsTypes, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DevicePayloadApiFactory = DevicePayloadApiFactory;
/**
 * DevicePayloadApi - object-oriented interface
 * @export
 * @class DevicePayloadApi
 * @extends {BaseAPI}
 */
var DevicePayloadApi = /** @class */ (function (_super) {
    __extends(DevicePayloadApi, _super);
    function DevicePayloadApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Retrieves a list of device payloads
     * @param {Array<string>} [serialNumbers] Filter to devices in list
     * @param {Array<IDevicePayloadTypeEnum>} [payloadType] Filter to only return device payloads of the types in the list
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicePayloadApi
     */
    DevicePayloadApi.prototype.getDevicePayload = function (serialNumbers, payloadType, options) {
        var _this = this;
        return (0, exports.DevicePayloadApiFp)(this.configuration).getDevicePayload(serialNumbers, payloadType, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves device payload for a specific device
     * @param {string} serialNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicePayloadApi
     */
    DevicePayloadApi.prototype.getDevicePayloadBySerialNumber = function (serialNumber, options) {
        var _this = this;
        return (0, exports.DevicePayloadApiFp)(this.configuration).getDevicePayloadBySerialNumber(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a list of device payload summaries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicePayloadApi
     */
    DevicePayloadApi.prototype.getDevicePayloadSummaries = function (options) {
        var _this = this;
        return (0, exports.DevicePayloadApiFp)(this.configuration).getDevicePayloadSummaries(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a list of settings device payloads
     * @param {Array<string>} [serialNumbers] Filter to devices in list
     * @param {Array<IDevicePayloadSettingsPayloadTypeEnum>} [settingsTypes] Filter to only return device payloads of the settings type in the list.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicePayloadApi
     */
    DevicePayloadApi.prototype.getSettingsDevicePayloads = function (serialNumbers, settingsTypes, options) {
        var _this = this;
        return (0, exports.DevicePayloadApiFp)(this.configuration).getSettingsDevicePayloads(serialNumbers, settingsTypes, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DevicePayloadApi;
}(base_1.BaseAPI));
exports.DevicePayloadApi = DevicePayloadApi;
/**
 * DevicesApi - axios parameter creator
 * @export
 */
var DevicesApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Retrieves a specific device
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceBySerialNumber: function (serialNumber, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'serialNumber' is not null or undefined
                    (0, common_1.assertParamExists)('getDeviceBySerialNumber', 'serialNumber', serialNumber);
                    localVarPath = "/cowtroller/devices/{serialNumber}"
                        .replace("{".concat("serialNumber", "}"), encodeURIComponent(String(serialNumber)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a list of device state summaries for the context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceStateSummaries: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/device-states/summaries";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a list of device states for the context farm
         * @param {Array<string>} [serialNumbers] Filter device states to devices in list
         * @param {Array<string>} [referenceIds] Filter to only return statuses of current command for the referenceIds in list
         * @param {boolean} [excludeTaggedOff] Filter to only return devices that are tagged on
         * @param {Array<DeviceCommandStatusEnum>} [excludeStatuses] Filter to only return device commands that don\&#39;t have the given statuses
         * @param {CommandTypeEnum} [type] Filter to only return device commands of the matching type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceStates: function (serialNumbers, referenceIds, excludeTaggedOff, excludeStatuses, type, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/device-states";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (serialNumbers) {
                        localVarQueryParameter['serialNumbers'] = serialNumbers;
                    }
                    if (referenceIds) {
                        localVarQueryParameter['referenceIds'] = referenceIds;
                    }
                    if (excludeTaggedOff !== undefined) {
                        localVarQueryParameter['excludeTaggedOff'] = excludeTaggedOff;
                    }
                    if (excludeStatuses) {
                        localVarQueryParameter['excludeStatuses'] = excludeStatuses;
                    }
                    if (type !== undefined) {
                        localVarQueryParameter['type'] = type;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves a a list of devices for the context farm
         * @param {string} [groupId]
         * @param {DeviceCommandStatusEnum} [commandStatus] Will query only devices that contain commands with the given status. The currentCommands field will only contain the status matching the parameter as well
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevices: function (groupId, commandStatus, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/devices/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (groupId !== undefined) {
                        localVarQueryParameter['groupId'] = groupId;
                    }
                    if (commandStatus !== undefined) {
                        localVarQueryParameter['commandStatus'] = commandStatus;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Endpoint to ingest device metrics batch
         * @param {IDeviceNotificationBatchRequestDTO} iDeviceNotificationBatchRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleDeviceMetricsBatch: function (iDeviceNotificationBatchRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'iDeviceNotificationBatchRequestDTO' is not null or undefined
                    (0, common_1.assertParamExists)('handleDeviceMetricsBatch', 'iDeviceNotificationBatchRequestDTO', iDeviceNotificationBatchRequestDTO);
                    localVarPath = "/cowtroller/device-metrics-batch";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iDeviceNotificationBatchRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DevicesApiAxiosParamCreator = DevicesApiAxiosParamCreator;
/**
 * DevicesApi - functional programming interface
 * @export
 */
var DevicesApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DevicesApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Retrieves a specific device
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceBySerialNumber: function (serialNumber, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeviceBySerialNumber(serialNumber, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a list of device state summaries for the context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceStateSummaries: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeviceStateSummaries(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a list of device states for the context farm
         * @param {Array<string>} [serialNumbers] Filter device states to devices in list
         * @param {Array<string>} [referenceIds] Filter to only return statuses of current command for the referenceIds in list
         * @param {boolean} [excludeTaggedOff] Filter to only return devices that are tagged on
         * @param {Array<DeviceCommandStatusEnum>} [excludeStatuses] Filter to only return device commands that don\&#39;t have the given statuses
         * @param {CommandTypeEnum} [type] Filter to only return device commands of the matching type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceStates: function (serialNumbers, referenceIds, excludeTaggedOff, excludeStatuses, type, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDeviceStates(serialNumbers, referenceIds, excludeTaggedOff, excludeStatuses, type, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves a a list of devices for the context farm
         * @param {string} [groupId]
         * @param {DeviceCommandStatusEnum} [commandStatus] Will query only devices that contain commands with the given status. The currentCommands field will only contain the status matching the parameter as well
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevices: function (groupId, commandStatus, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDevices(groupId, commandStatus, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Endpoint to ingest device metrics batch
         * @param {IDeviceNotificationBatchRequestDTO} iDeviceNotificationBatchRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleDeviceMetricsBatch: function (iDeviceNotificationBatchRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.handleDeviceMetricsBatch(iDeviceNotificationBatchRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DevicesApiFp = DevicesApiFp;
/**
 * DevicesApi - factory interface
 * @export
 */
var DevicesApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DevicesApiFp)(configuration);
    return {
        /**
         *
         * @summary Retrieves a specific device
         * @param {string} serialNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceBySerialNumber: function (serialNumber, options) {
            return localVarFp.getDeviceBySerialNumber(serialNumber, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a list of device state summaries for the context farm
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceStateSummaries: function (options) {
            return localVarFp.getDeviceStateSummaries(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a list of device states for the context farm
         * @param {Array<string>} [serialNumbers] Filter device states to devices in list
         * @param {Array<string>} [referenceIds] Filter to only return statuses of current command for the referenceIds in list
         * @param {boolean} [excludeTaggedOff] Filter to only return devices that are tagged on
         * @param {Array<DeviceCommandStatusEnum>} [excludeStatuses] Filter to only return device commands that don\&#39;t have the given statuses
         * @param {CommandTypeEnum} [type] Filter to only return device commands of the matching type
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceStates: function (serialNumbers, referenceIds, excludeTaggedOff, excludeStatuses, type, options) {
            return localVarFp.getDeviceStates(serialNumbers, referenceIds, excludeTaggedOff, excludeStatuses, type, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves a a list of devices for the context farm
         * @param {string} [groupId]
         * @param {DeviceCommandStatusEnum} [commandStatus] Will query only devices that contain commands with the given status. The currentCommands field will only contain the status matching the parameter as well
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevices: function (groupId, commandStatus, options) {
            return localVarFp.getDevices(groupId, commandStatus, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Endpoint to ingest device metrics batch
         * @param {IDeviceNotificationBatchRequestDTO} iDeviceNotificationBatchRequestDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        handleDeviceMetricsBatch: function (iDeviceNotificationBatchRequestDTO, options) {
            return localVarFp.handleDeviceMetricsBatch(iDeviceNotificationBatchRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DevicesApiFactory = DevicesApiFactory;
/**
 * DevicesApi - object-oriented interface
 * @export
 * @class DevicesApi
 * @extends {BaseAPI}
 */
var DevicesApi = /** @class */ (function (_super) {
    __extends(DevicesApi, _super);
    function DevicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Retrieves a specific device
     * @param {string} serialNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.getDeviceBySerialNumber = function (serialNumber, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).getDeviceBySerialNumber(serialNumber, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a list of device state summaries for the context farm
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.getDeviceStateSummaries = function (options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).getDeviceStateSummaries(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a list of device states for the context farm
     * @param {Array<string>} [serialNumbers] Filter device states to devices in list
     * @param {Array<string>} [referenceIds] Filter to only return statuses of current command for the referenceIds in list
     * @param {boolean} [excludeTaggedOff] Filter to only return devices that are tagged on
     * @param {Array<DeviceCommandStatusEnum>} [excludeStatuses] Filter to only return device commands that don\&#39;t have the given statuses
     * @param {CommandTypeEnum} [type] Filter to only return device commands of the matching type
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.getDeviceStates = function (serialNumbers, referenceIds, excludeTaggedOff, excludeStatuses, type, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).getDeviceStates(serialNumbers, referenceIds, excludeTaggedOff, excludeStatuses, type, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves a a list of devices for the context farm
     * @param {string} [groupId]
     * @param {DeviceCommandStatusEnum} [commandStatus] Will query only devices that contain commands with the given status. The currentCommands field will only contain the status matching the parameter as well
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.getDevices = function (groupId, commandStatus, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).getDevices(groupId, commandStatus, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Endpoint to ingest device metrics batch
     * @param {IDeviceNotificationBatchRequestDTO} iDeviceNotificationBatchRequestDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    DevicesApi.prototype.handleDeviceMetricsBatch = function (iDeviceNotificationBatchRequestDTO, options) {
        var _this = this;
        return (0, exports.DevicesApiFp)(this.configuration).handleDeviceMetricsBatch(iDeviceNotificationBatchRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DevicesApi;
}(base_1.BaseAPI));
exports.DevicesApi = DevicesApi;
/**
 * EmergencyReleaseApi - axios parameter creator
 * @export
 */
var EmergencyReleaseApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Disable \'emergency release\' mode for all collars of a given farm by re-enabling CowG on collars. This endpoint will be called by the mobile app when the farmer wants to re-enable collars. This mode is  initially set from the mobile app to collars bypassing any backend service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateEmergencyRelease: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/emergency-release";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.EmergencyReleaseApiAxiosParamCreator = EmergencyReleaseApiAxiosParamCreator;
/**
 * EmergencyReleaseApi - functional programming interface
 * @export
 */
var EmergencyReleaseApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EmergencyReleaseApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Disable \'emergency release\' mode for all collars of a given farm by re-enabling CowG on collars. This endpoint will be called by the mobile app when the farmer wants to re-enable collars. This mode is  initially set from the mobile app to collars bypassing any backend service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateEmergencyRelease: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deactivateEmergencyRelease(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.EmergencyReleaseApiFp = EmergencyReleaseApiFp;
/**
 * EmergencyReleaseApi - factory interface
 * @export
 */
var EmergencyReleaseApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EmergencyReleaseApiFp)(configuration);
    return {
        /**
         *
         * @summary Disable \'emergency release\' mode for all collars of a given farm by re-enabling CowG on collars. This endpoint will be called by the mobile app when the farmer wants to re-enable collars. This mode is  initially set from the mobile app to collars bypassing any backend service
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateEmergencyRelease: function (options) {
            return localVarFp.deactivateEmergencyRelease(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EmergencyReleaseApiFactory = EmergencyReleaseApiFactory;
/**
 * EmergencyReleaseApi - object-oriented interface
 * @export
 * @class EmergencyReleaseApi
 * @extends {BaseAPI}
 */
var EmergencyReleaseApi = /** @class */ (function (_super) {
    __extends(EmergencyReleaseApi, _super);
    function EmergencyReleaseApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Disable \'emergency release\' mode for all collars of a given farm by re-enabling CowG on collars. This endpoint will be called by the mobile app when the farmer wants to re-enable collars. This mode is  initially set from the mobile app to collars bypassing any backend service
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmergencyReleaseApi
     */
    EmergencyReleaseApi.prototype.deactivateEmergencyRelease = function (options) {
        var _this = this;
        return (0, exports.EmergencyReleaseApiFp)(this.configuration).deactivateEmergencyRelease(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EmergencyReleaseApi;
}(base_1.BaseAPI));
exports.EmergencyReleaseApi = EmergencyReleaseApi;
/**
 * GroupsApi - axios parameter creator
 * @export
 */
var GroupsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Retrives information on groups
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupById: function (groupId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    // verify required parameter 'groupId' is not null or undefined
                    (0, common_1.assertParamExists)('getGroupById', 'groupId', groupId);
                    localVarPath = "/cowtroller/groups/{groupId}"
                        .replace("{".concat("groupId", "}"), encodeURIComponent(String(groupId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrives information on groups
         * @param {string} [paddockId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: function (paddockId, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/groups";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paddockId !== undefined) {
                        localVarQueryParameter['paddockId'] = paddockId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.GroupsApiAxiosParamCreator = GroupsApiAxiosParamCreator;
/**
 * GroupsApi - functional programming interface
 * @export
 */
var GroupsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.GroupsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Retrives information on groups
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupById: function (groupId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getGroupById(groupId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrives information on groups
         * @param {string} [paddockId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: function (paddockId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getGroups(paddockId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.GroupsApiFp = GroupsApiFp;
/**
 * GroupsApi - factory interface
 * @export
 */
var GroupsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.GroupsApiFp)(configuration);
    return {
        /**
         *
         * @summary Retrives information on groups
         * @param {string} groupId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupById: function (groupId, options) {
            return localVarFp.getGroupById(groupId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrives information on groups
         * @param {string} [paddockId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: function (paddockId, options) {
            return localVarFp.getGroups(paddockId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.GroupsApiFactory = GroupsApiFactory;
/**
 * GroupsApi - object-oriented interface
 * @export
 * @class GroupsApi
 * @extends {BaseAPI}
 */
var GroupsApi = /** @class */ (function (_super) {
    __extends(GroupsApi, _super);
    function GroupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Retrives information on groups
     * @param {string} groupId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    GroupsApi.prototype.getGroupById = function (groupId, options) {
        var _this = this;
        return (0, exports.GroupsApiFp)(this.configuration).getGroupById(groupId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrives information on groups
     * @param {string} [paddockId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupsApi
     */
    GroupsApi.prototype.getGroups = function (paddockId, options) {
        var _this = this;
        return (0, exports.GroupsApiFp)(this.configuration).getGroups(paddockId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GroupsApi;
}(base_1.BaseAPI));
exports.GroupsApi = GroupsApi;
/**
 * ProtrackDraftingApi - axios parameter creator
 * @export
 */
var ProtrackDraftingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Retrieves current protrack drafting state
         * @param {Array<string>} [cattleIds] List of cattleIds to filter results to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftingState: function (cattleIds, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/protrack-drafting/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (cattleIds) {
                        localVarQueryParameter['cattleIds'] = cattleIds;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Retrieves current protrack drafting to be synced to protrack server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftingsToBeSynced: function (options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/protrack-drafting/sync";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @param {Array<IRemoveProtrackDraftingRequestDTO>} [iRemoveProtrackDraftingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDrafting: function (iRemoveProtrackDraftingRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/protrack-drafting/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iRemoveProtrackDraftingRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Adds a cow to be shifted via protrack
         * @param {Array<IProtrackDraftingRequestDTO>} [iProtrackDraftingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleDrafting: function (iProtrackDraftingRequestDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/protrack-drafting/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iProtrackDraftingRequestDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Sends back to backend the current state on protrack server (all the cows). If a cow is not listed in the backend, but present on the request, it will insert as new schedule in the backend
         * @param {Array<IReportedProtrackDraftingStateDTO>} [iReportedProtrackDraftingStateDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncState: function (iReportedProtrackDraftingStateDTO, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/cowtroller/protrack-drafting/sync";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(iReportedProtrackDraftingStateDTO, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ProtrackDraftingApiAxiosParamCreator = ProtrackDraftingApiAxiosParamCreator;
/**
 * ProtrackDraftingApi - functional programming interface
 * @export
 */
var ProtrackDraftingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ProtrackDraftingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Retrieves current protrack drafting state
         * @param {Array<string>} [cattleIds] List of cattleIds to filter results to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftingState: function (cattleIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDraftingState(cattleIds, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Retrieves current protrack drafting to be synced to protrack server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftingsToBeSynced: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDraftingsToBeSynced(options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @param {Array<IRemoveProtrackDraftingRequestDTO>} [iRemoveProtrackDraftingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDrafting: function (iRemoveProtrackDraftingRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeDrafting(iRemoveProtrackDraftingRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Adds a cow to be shifted via protrack
         * @param {Array<IProtrackDraftingRequestDTO>} [iProtrackDraftingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleDrafting: function (iProtrackDraftingRequestDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.scheduleDrafting(iProtrackDraftingRequestDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        /**
         *
         * @summary Sends back to backend the current state on protrack server (all the cows). If a cow is not listed in the backend, but present on the request, it will insert as new schedule in the backend
         * @param {Array<IReportedProtrackDraftingStateDTO>} [iReportedProtrackDraftingStateDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncState: function (iReportedProtrackDraftingStateDTO, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSyncState(iReportedProtrackDraftingStateDTO, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.ProtrackDraftingApiFp = ProtrackDraftingApiFp;
/**
 * ProtrackDraftingApi - factory interface
 * @export
 */
var ProtrackDraftingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ProtrackDraftingApiFp)(configuration);
    return {
        /**
         *
         * @summary Retrieves current protrack drafting state
         * @param {Array<string>} [cattleIds] List of cattleIds to filter results to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftingState: function (cattleIds, options) {
            return localVarFp.getDraftingState(cattleIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Retrieves current protrack drafting to be synced to protrack server
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDraftingsToBeSynced: function (options) {
            return localVarFp.getDraftingsToBeSynced(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @param {Array<IRemoveProtrackDraftingRequestDTO>} [iRemoveProtrackDraftingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDrafting: function (iRemoveProtrackDraftingRequestDTO, options) {
            return localVarFp.removeDrafting(iRemoveProtrackDraftingRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Adds a cow to be shifted via protrack
         * @param {Array<IProtrackDraftingRequestDTO>} [iProtrackDraftingRequestDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scheduleDrafting: function (iProtrackDraftingRequestDTO, options) {
            return localVarFp.scheduleDrafting(iProtrackDraftingRequestDTO, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Sends back to backend the current state on protrack server (all the cows). If a cow is not listed in the backend, but present on the request, it will insert as new schedule in the backend
         * @param {Array<IReportedProtrackDraftingStateDTO>} [iReportedProtrackDraftingStateDTO]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyncState: function (iReportedProtrackDraftingStateDTO, options) {
            return localVarFp.updateSyncState(iReportedProtrackDraftingStateDTO, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ProtrackDraftingApiFactory = ProtrackDraftingApiFactory;
/**
 * ProtrackDraftingApi - object-oriented interface
 * @export
 * @class ProtrackDraftingApi
 * @extends {BaseAPI}
 */
var ProtrackDraftingApi = /** @class */ (function (_super) {
    __extends(ProtrackDraftingApi, _super);
    function ProtrackDraftingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Retrieves current protrack drafting state
     * @param {Array<string>} [cattleIds] List of cattleIds to filter results to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtrackDraftingApi
     */
    ProtrackDraftingApi.prototype.getDraftingState = function (cattleIds, options) {
        var _this = this;
        return (0, exports.ProtrackDraftingApiFp)(this.configuration).getDraftingState(cattleIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Retrieves current protrack drafting to be synced to protrack server
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtrackDraftingApi
     */
    ProtrackDraftingApi.prototype.getDraftingsToBeSynced = function (options) {
        var _this = this;
        return (0, exports.ProtrackDraftingApiFp)(this.configuration).getDraftingsToBeSynced(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @param {Array<IRemoveProtrackDraftingRequestDTO>} [iRemoveProtrackDraftingRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtrackDraftingApi
     */
    ProtrackDraftingApi.prototype.removeDrafting = function (iRemoveProtrackDraftingRequestDTO, options) {
        var _this = this;
        return (0, exports.ProtrackDraftingApiFp)(this.configuration).removeDrafting(iRemoveProtrackDraftingRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Adds a cow to be shifted via protrack
     * @param {Array<IProtrackDraftingRequestDTO>} [iProtrackDraftingRequestDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtrackDraftingApi
     */
    ProtrackDraftingApi.prototype.scheduleDrafting = function (iProtrackDraftingRequestDTO, options) {
        var _this = this;
        return (0, exports.ProtrackDraftingApiFp)(this.configuration).scheduleDrafting(iProtrackDraftingRequestDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Sends back to backend the current state on protrack server (all the cows). If a cow is not listed in the backend, but present on the request, it will insert as new schedule in the backend
     * @param {Array<IReportedProtrackDraftingStateDTO>} [iReportedProtrackDraftingStateDTO]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtrackDraftingApi
     */
    ProtrackDraftingApi.prototype.updateSyncState = function (iReportedProtrackDraftingStateDTO, options) {
        var _this = this;
        return (0, exports.ProtrackDraftingApiFp)(this.configuration).updateSyncState(iReportedProtrackDraftingStateDTO, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ProtrackDraftingApi;
}(base_1.BaseAPI));
exports.ProtrackDraftingApi = ProtrackDraftingApi;
